import React, { useState, useEffect } from 'react';

export const UserReferenceTooltip: React.FC<Props> = ({
  userRefTooltipMessage,
  view
}) => {
  const [pointerMove, setpointerMove] = useState<any>(null);

  useEffect(() => {
    if (view) {
      const pointerMoveFn = (e: any) => {
        const dt = document.getElementById('userReferenceTooltipContainer');
        if (dt) {
          dt.style.left = `${e.x + 300}px`;
          dt.style.top = `${e.y + 140}px`;
          dt.style.display = 'block';
        }
      };
      const pointerMoveEvt = view.on('pointer-move', pointerMoveFn);
      setpointerMove(pointerMoveEvt);
    }
  }, [view]);

  useEffect(() => {
    return () => {
      pointerMove && pointerMove.remove();
    };
  }, [pointerMove]);

  return (
    <div
      id="userReferenceTooltipContainer"
      className="user-reference-tooltip-container"
    >
      {userRefTooltipMessage !== '' && (
        <div id="userReferenceTooltip" className="user-reference-tooltip">
          {userRefTooltipMessage}
        </div>
      )}
    </div>
  );
};

type Props = {
  userRefTooltipMessage: string;
  view: any;
};

export default React.memo(UserReferenceTooltip);
